<template>
  <div class="block-head" :style="{ backgroundImage: `url(${imgPath}/1.svg)` }">
    <bimContainer>
      <bimCol cols=12 md=10 class="mx-auto">
        <bim-text adaptive type=h3 bold>Помогаем продавать больше</bim-text>
        <bim-text adaptive type=accent class="my-9">Продвижение цифровых двойников вашей продукции</bim-text>
        <bim-button label="Узнать больше" size=l @click="$emit('leaveRequest', 'Узнать больше')" />

        <a href="#promotion-info" class="block-head__info d-flex">
          <img :src="`${imgPath}/arrow-down.svg`" alt="" />
          <bim-text adaptive type=desc class="mx-3" bold>подробности ниже</bim-text>
          <img :src="`${imgPath}/arrow-down.svg`" alt="" />
        </a>
      </bimCol>
    </bimContainer>
  </div>
</template>

<script>
import bimButton from "@bimlib/components/bimButton"
import bimCol from "@bimlib/components/bimCol"
import bimContainer from "@bimlib/components/bimContainer"
export default {
  inject: ['imgPath'],
  name: "",
  components: {
    bimButton,
    bimCol,
    bimContainer,
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

.block-head {
  padding: 208px 0 116px;
  background-repeat: no-repeat;
  background-position: center;

  @media screen and (max-width: $breakpoint-sm) {
    padding: 52px 0 28px;
    background-image: none !important;
  }

  .block-head__info {
    padding-top: 290px;
    color: $primary-color;
    text-transform: uppercase;

    @media screen and (max-width: $breakpoint-sm) {
      padding-top: 50px;
      background-image: none !important;
    }
  }
}
</style>
